// export const AXIOS_API = process.env.NODE_ENV == 'production' ? 'http://54.86.14.55:8080' : 'http://10.16.6.137:8080'

let url = ''
console.log('process.env.NODE_ENV', process.env.NODE_ENV)
if(process.env.NODE_ENV === 'production'){
    // url = 'http://54.86.14.55:8080'
    url = '/api'
}else if(process.env.NODE_ENV === 'development'){
    url = 'http://base0656.base-fx.com:8080'
    // url = 'http://10.16.6.137:8080'
    // url = 'http://10.16.6.160:8080'         // ming hui
    // url = 'http://10.16.6.102:8080'      // alex
    // url = 'http://10.16.6.160:8082'        // 重构
}else if(process.env.NODE_ENV === 'dev'){
    url = 'http://54.86.14.55:8070'
}else if(process.env.NODE_ENV === 'beta') {
    url = '/api'
}

export const AXIOS_API = url // test环境用
